import styled from 'styled-components'

export const VideoRecordingContainer = styled.div`
  margin: 0 auto;
  padding: 0 0 96px 0;
  max-width: 1530px;
  position: relative;

  .Load__More-Speakers {
    text-align: center;
    padding-top: 64px;
    position: relative;

    .Button__Box {
      display: inline-block;

      &::before,
      &::after {
        content: '';
        position: absolute;
        background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[35]};
        height: 1px;
        width: calc(50% - 142px);
        top: 89px;
        z-index: 0;
      }

      &::before {
        left: 16px;
      }

      &::after {
        right: 16px;
      }
    }

    .CTA__Arrow-Container {
      display: none;
    }
  }

  /* Spinner Animation */
  .spinner-load {
    margin: 96px auto;
    width: 70px;
    text-align: center;
    z-index: 9;
    position: relative;

    > div {
      width: 18px;
      height: 18px;
      background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;

      &.bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
      }

      &.bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
      }
    }
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  /* Share Popup */
  .Video__Share-Popup {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1010;
    max-width: 250px;
    min-width: 250px;
    padding: 1px;
    text-align: left;
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    background-clip: padding-box;
    border: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[35]};
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
    box-shadow: 0 5px 10px ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
    white-space: normal;
    height: 100px;

    .Video__Share-Arrow {
      border-width: 11px;
      position: absolute;
      display: block;
      width: 0px;
      height: 0px;
      border-color: transparent;
      border-style: solid;
      &:after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        border-width: 10px;
        content: '';
      }
    }

    &.bottom {
      margin-top: 10px;
      .Video__Share-Arrow {
        left: 80%;
        margin-left: -11px;
        border-top-width: 0;
        border-bottom-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[35]};
        top: -11px;

        &:after {
          content: ' ';
          top: 1px;
          margin-left: -10px;
          border-top-width: 0;
          border-bottom-color: ${({ theme }) => theme.webMktNewPalette.white};
        }
      }
    }

    .Video__Share-Content {
      padding: 20px 15px;

      @media (max-width: 767px) {
        .Video__Share-Content {
          padding: 15px 8px;
        }
      }

      .Video__Share-title {
        font-size: 13px;
        font-weight: 600;
        padding-bottom: 5px;
      }

      .Video__Share-clipboard {
        .Video__Share-InputGroup {
          position: relative;
          display: flex;
          border-collapse: separate;
          background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};

          .Video__Share-FormControl {
            border: none;
            border-radius: 0px;
            font-family: 'Titillium Web', sans-serif;
            font-size: 12px;
            z-index: 0;
            border-radius: 9px;
            background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
            padding: 9px;
            outline: none;
          }

          span.Video__Share-CopyBtn {
            background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
            color: ${({ theme }) => theme.webMktNewPalette.white};
            font-size: 11px;
            padding: 0px 10px;
            border-radius: 3px;
            text-transform: uppercase;
            cursor: pointer;
            width: 50px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
              width: 16px;
              height: 16px;
            }
          }
        }
      }

      .Video__Share-SuccessText {
        font-size: 11px;
        color: ${({ theme }) => theme.webMktPalette.text.actionOrange};
        text-align: right;
        margin-top: 5px;
      }
    }
  }
`

export const CardSearch = styled.div`
  padding-bottom: 40px;
  max-width: 908px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 0px auto;
  position: relative;

  input {
    border-radius: 40px;
    border: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
    background: ${({ theme }) => theme.webMktNewPalette.white};
    max-width: 908px;
    width: 100%;
    padding: 16px 90px 16px 24px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin: 0 16px;
    }
  }
  svg {
    position: absolute;
    right: 24px;
    width: 24px;
    height: 24px;
    fill: ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
    transition: 0.2s;
    top: 16px;
    pointer-events: all;
    cursor: pointer;

    &.ClearSearch {
      right: 56px;
    }

    &:hover {
      fill: ${({ theme }) => theme.webMktNewPalette.alphaBlack[10]};
    }
  }
`

export const VideoRecordingFilters = styled.div`
  padding: 0 0 64px 0;
  .Category-Filters {
    display: flex;
    min-height: 56px;
    padding: 0px 24px;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    flex-wrap: wrap;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-wrap: nowrap;
      overflow-x: scroll;
      justify-content: flex-start;
    }

    .Category {
      border-radius: 40px;
      border: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
      background: ${({ theme }) => theme.webMktNewPalette.white};
      padding: 16px 24px;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin-right: 8px;
      margin-bottom: 16px;
      cursor: pointer;
      text-transform: capitalize;
      text-wrap: nowrap;
      white-space-collapse: collapse;
      transition: all 0.4s;

      ${({ theme }) => theme.breakpoints.down('xs')} {
        margin-bottom: 0;
      }

      &:hover,
      &.active {
        background: ${({ theme }) => theme.webMktNewPalette.black};
        color: ${({ theme }) => theme.webMktNewPalette.white};
      }
    }
  }
`

export const VideoRecordingList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 72px;
  column-gap: 154px;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    gap: 64px;
    margin: 0 60px;
    width: calc(100% - 120px);
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    gap: 32px;
    margin: 0 32px;
    width: calc(100% - 64px);
    justify-content: space-between;
  }
  ${({ theme }) => theme.breakpoints.down('xs')} {
    flex-direction: column;
    gap: 64px;
    margin: 0 63px;
    width: calc(100% - 126px);
  }
  @media (max-width: 767px) {
    margin: 0 16px;
    width: calc(100% - 32px);
  }
`
export const VideoRecordingNotFound = styled.div`
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
`

export const VideoCard = styled.div<{
  $descShowMore: boolean
}>`
  max-width: 688px;
  width: calc(50% - 64px);

  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: calc(50% - 32px);
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    max-width: 548px;
  }
  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
    max-width: 100%;
  }

  .Video__Card-Box {
    padding-bottom: 72px;
    position: relative;

    ${({ theme }) => theme.breakpoints.down('md')} {
      padding-bottom: 64px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      padding-bottom: 57px;
    }

    @media (max-width: 767px) {
      padding-bottom: 32px;
      &::before {
        display: none;
      }
    }

    &::before {
      content: '';
      position: absolute;
      background-image: url('https://images.ctfassets.net/5965pury2lcm/fvncMUuhUu5pISQQQgNy1/fc254f0dbe7105afc5414efdd742a97d/dotted-pattern.png');
      width: 360px;
      height: 240px;
      right: -46px;
      bottom: 22px;
      z-index: -1;
    }

    .VideoPlayer__Image-File {
      width: 100%;
      height: 388px;
      object-fit: cover;
      object-position: center center;

      ${({ theme }) => theme.breakpoints.down('md')} {
        height: 294px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        height: auto;
        max-height: 364px;
      }
      @media (max-width: 767px) {
        box-shadow: 0px 40px 24px -24px ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
      }
      @media (max-width: 375px) {
        max-height: 185px;
      }
    }
  }
  .Video__Card-Content {
    p {
      margin: 0;
    }
    .Video__Social {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        margin-bottom: 20px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        margin-bottom: 16px;
      }

      .Video__Category {
        color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        position: relative;
        padding-left: 56px;

        &::before {
          content: '';
          background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
          height: 4px;
          width: 44px;
          position: absolute;
          left: 0;
          top: 10px;
        }

        ${({ theme }) => theme.breakpoints.down('xs')} {
          line-height: 20px;
          padding-left: 42px;
          &::before {
            width: 30px;
          }
        }
      }
      .Video__Share {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }

        svg {
          padding-left: 8px;
          pointer-events: none;
        }
      }
    }

    .Video__Title {
      font-size: 28px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -1px;
      margin-bottom: 16px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        font-size: 24px;
        line-height: 28px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 26px;
        line-height: 32px;
        letter-spacing: normal;
      }

      @media (max-width: 767px) {
        font-size: 22px;
        line-height: 28px;
      }
    }
    .Video__Description {
      margin-bottom: 16px;
      display: block;
      overflow: hidden;

      display: ${({ $descShowMore }) => ($descShowMore ? 'inherit' : '-webkit-box')};
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      white-space: normal;
      text-overflow: ellipsis;

      p {
        color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
    }
    .Description__MoreLess {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      margin-bottom: 24px;
      position: relative;
      overflow: hidden;

      span.text {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      &:after {
        content: '';
        position: absolute;
        background: ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
        width: 100%;
        height: 1px;
        top: 50%;
        z-index: -1;
        right: -112px;
      }
    }
  }
`

export const VideoSpeakerList = styled.div`
  &.Video__SpeakerList {
    .Video__SpeakerList-Top,
    .Video__SpeakerList-Bottom {
      display: flex;
      flex-flow: wrap;
      gap: 26px;
      width: 100%;
      margin-bottom: 26px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        flex-direction: column;
        gap: 16px;
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
        flex-direction: row;
        gap: 26px;
      }
    }

    .Video__Speaker-All {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      margin-bottom: 26px;
      position: relative;
      overflow: hidden;

      span.text {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      &:after {
        content: '';
        position: absolute;
        background: ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
        width: 100%;
        height: 1px;
        top: 50%;
        z-index: -1;
        right: -143px;
      }
    }
    .speaker {
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      width: calc(50% - 24px);

      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: calc(100% - 24px);
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
        width: calc(50% - 24px);
      }
      @media (max-width: 767px) {
        width: 100%;
      }

      .speaker-img {
        min-width: 80px;
        min-height: 80px;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          min-width: 64px;
          min-height: 64px;
        }

        .Headshot__Image {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background-color: ${({ theme }) => theme.webMktNewPalette.white};

          ${({ theme }) => theme.breakpoints.down('xs')} {
            width: 64px;
            height: 64px;
          }
        }
      }
      .speaker-info {
        margin-left: 16px;
        width: 73%;
        .name {
          color: ${({ theme }) => theme.webMktNewPalette.black};
          font-size: 20px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: -1px;
          margin-bottom: 2px;

          ${({ theme }) => theme.breakpoints.down('xs')} {
            font-size: 18px;
          }
        }
        .desg {
          color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          margin-bottom: 2px;
        }
        .company {
          color: ${({ theme }) => theme.webMktNewPalette.black};
          font-size: 12px;
          font-weight: 700;
          line-height: 16px;
        }
      }
    }
  }
`
